"use client";

import { useState } from "react";
import ProductVariants from "@/components/frontend/product/server/ProductVariants";
import QuantitySelector from "@/components/frontend/product/client/QuantitySelector";
import OrderSummary from "@/components/frontend/product/client/OrderSummary";
import { Product, ProductVariant } from "@/Types/responses/product";

type Props = {
    product: Product;
};

export default function ProductSummary({ product }: Props) {

    const hasVariants = (product.variants?.length ?? 0) > 0;

    const [quantity, setQuantity] = useState(1);
    const [selectedPrice, setSelectedPrice] = useState<number | null>(
        hasVariants ? null : product.productPrice
    );
    const [selectedVariant, setSelectedVariant] = useState<ProductVariant | null>(null);

    // Build selectedAttributes map (attributeId → value) from the matched variant
    const selectedAttributes = selectedVariant
        ? Object.fromEntries(selectedVariant.attributes.map(({ attribute, value }) => [attribute, value]))
        : undefined;

    // canOrder: variant products need a variant picked; simple products just need a valid price
    const canOrder = hasVariants ? Boolean(selectedVariant) : product.productPrice !== null;

    return (
        <div className="flex flex-col flex-1 space-y-6">

            {/* Name */}
            

            {/* Price */}
            {/* {selectedPrice !== null && (
                <h3 className="text-xs">
                    Starting from{" "}
                    <span className="text-redColor text-xl font-semibold">
                        KES {selectedPrice.toLocaleString()}
                    </span>
                </h3>
            )} */}

            {/* Variants */}
            {/* {hasVariants && (
                <ProductVariants
                    variants={product.variants}
                    attributes={product.attributes}
                    onPriceChange={setSelectedPrice}
                    onVariantChange={(variantId) => {
                        const match = product.variants.find((v) => v._id === variantId) ?? null;
                        setSelectedVariant(match);
                    }}
                />
            )} */}

            {/* Quantity */}
            <div className="flex flex-col gap-2 mt-4 lg:mt-0">
                <p className="md:text-lg">Order quantity</p>
                <QuantitySelector onChange={setQuantity} />
            </div>

            {/* Order summary */}
            <OrderSummary
                productId={product._id}
                productName={product.name}
                price={selectedPrice}
                quantity={quantity}
                selectedAttributes={selectedAttributes}
                canOrder={canOrder}
            />
        </div>
    );
}